'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { fetchPurchaseMotions } from 'pricing-pages-lib/api/EligibilityEngineApi';
import * as PurchaseMotionTypes from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import styled from 'styled-components';

const ConstantsTest = () => {
  const [eePurchaseMotions, setEePurchaseMotions] = useState(null);
  const fePurchaseMotions = Object.values(PurchaseMotionTypes);
  useEffect(() => {
    fetchPurchaseMotions().then(result => setEePurchaseMotions(result)).catch(err => console.log('err', err));
  }, []);

  if (!eePurchaseMotions) {
    return null;
  }

  const frontEndOnly = fePurchaseMotions.filter(type => !eePurchaseMotions.includes(type));
  const eligibilityEngineOnly = eePurchaseMotions.filter(type => !fePurchaseMotions.includes(type));
  const SectionTitle = styled.h3.withConfig({
    displayName: "ConstantsTest__SectionTitle",
    componentId: "sc-16sh99k-0"
  })(["margin-top:10px;margin-bottom:5px;"]);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      margin: '20px'
    },
    "data-selenium-id": "purchase-motions",
    children: [frontEndOnly.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: "UI-Addon-Upgrades Purchase Motions not present in E.E."
      }), /*#__PURE__*/_jsx("div", {
        children: frontEndOnly.map(value => /*#__PURE__*/_jsx("div", {
          "data-selenium-id": "back-end-purchase-motion",
          children: value
        }, value))
      })]
    }), eligibilityEngineOnly.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: "E.E. Purchase Motions not present in UI-Addon-Upgrades"
      }), /*#__PURE__*/_jsx("div", {
        children: eligibilityEngineOnly.map(value => /*#__PURE__*/_jsx("div", {
          "data-selenium-id": "back-end-purchase-motion",
          children: value
        }, value))
      })]
    })]
  });
};

export default ConstantsTest;